<template>
  <div class="modal-overlay">
    <div class="modal-background" @click="$emit('close')" />
    <div class="modal">
      <div class="title-close">
        <h1 class="modal-title">{{ $adminT('navigation.schedule_publish_1572', 'Schedule Publish') }}</h1>
        <span class="material-icons" @click="$emit('close')"> close </span>
      </div>
      <div class="description">
        {{ $adminT('navigation.schedule_explanation', 'The event is scheduled to be published at an approximate time. Please be aware that the publication may be delayed by up to 15 minutes.') }}
      </div>
      <div class="inputs-container">
        <date-field
          :admin-context="true"
          v-model="publishDate"
          label="dd.mm.yyyy"
          format="DD.MM.YYYY."
          :validator="$v.publishDate"
        />
        <time-field
          :admin-context="true"
          v-model="publishTime"
          label="hh:mm"
          :validator="$v.publishTime"
          style="flex: 1"
        />
      </div>
      <div class="buttons-cancel-schedule">
        <main-button outline @click="$emit('close')">{{ $adminT('navigation.cancel', 'Cancel') }}</main-button>
        <main-button @click="onScheduleClick">{{ $adminT('navigation.schedule', 'Schedule') }}</main-button>
      </div>
    </div>
  </div>
</template>
<script>

import { required } from 'vuelidate/lib/validators'
import moment from 'moment/moment'

export default {
  name: 'schedule-publish-modal',
  props: {
    cover: String,
    initialValue: String,
  },
  data() {
    let publishDate = null
    let publishTime = null
    if (this.initialValue) {
      publishDate = this.initialValue
      publishTime = moment(this.initialValue).format('HH:mm')
    }

    return {
      publishDate,
      publishTime,
    }
  },
  validations() {
    return {
      publishDate: { required },
      publishTime: { required },
    }
  },
  methods: {
    onScheduleClick() {
      this.$v.$touch()
      if (this.$v.$invalid) {
        return
      }

      this.$emit('schedule', moment(this.publishDate).format('YYYY-MM-DD'), this.publishTime)
    },
  },
}
</script>
<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}

.modal-background {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #00000050;
}

.modal {
  text-align: left;
  background-color: white;
  width: 100%;
  position: relative;
  max-width: 33rem;
  padding: 2rem;
  border-radius: 20px;
  overflow-y: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
  max-height: 100%;
}

.modal::-webkit-scrollbar {
  display: none;
}

.modal-title {
  color: #0277bd;
  font-variant-numeric: lining-nums proportional-nums;
  font-family: Raleway;
  font-size: 1.25rem;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
  letter-spacing: -0.0375rem;
}

.title-close {
  margin-bottom: 0.75rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.material-icons {
  cursor: pointer;
}

.description {
  color: #979797;
  font-family: "Source Sans Pro";
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
}

.inputs-container {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1.5rem;
  align-self: stretch;
}

.buttons-cancel-schedule {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  align-self: stretch;
  margin-top: 1rem;
}

@media screen and (max-width: 425px) {
  .inputs-container {
    flex-direction: column;
    align-items: center;
  }
}

@media screen and (max-width: 288px) {
  .buttons-cancel-schedule {
    flex-direction: column;
    align-items: center;
  }
}
</style>

